import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { useInviteUserContext } from '../../context/invite-user-context';
import { UserForm } from '../../../user-form/components/user-form';

interface InviteUserFormWizardScreenProps {
  error?: string;
  onClose: () => void;
  onInvite: () => void;
}

export const InviteUserFormWizardScreen = ({ error, onClose, onInvite }: InviteUserFormWizardScreenProps) => {
  const { form } = useInviteUserContext();
  const intl = useIntl();

  return (
    <WizardScreen
      createText={intl.formatMessage({ id: 'common.invite', defaultMessage: 'Invite' })}
      footerMode={FooterMode.CREATE}
      onCancel={onClose}
      onCreate={onInvite}
    >
      <>
        {error && <WizardFormError message={error} mb={3} />}
        <WizardFormValidationErrorSummary errors={form.errors} mb={3} />
        <UserForm form={form} />
      </>
    </WizardScreen>
  );
};
